// Polyfills required for babel
// https://babeljs.io/docs/usage/polyfill/#usage-in-node-browserify-webpack
import 'babel-polyfill';

import './index.css';

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

window.__webview_comms__.on('ready', () =>
  ReactDOM.render(<App />, document.getElementById('root'))
);

/*
  _  __                              ____        _   _
 | |/ /                             / __ \      | | | |
 | ' / ___  ___  __ _  __ _ _ __   | |  | |_   _| |_| |
 |  < / _ \/ _ \/ _` |/ _` | '_ \  | |  | | | | | __| |
 | . \  __/  __/ (_| | (_| | | | | | |__| | |_| | |_|_|
 |_|\_\___|\___|\__, |\__,_|_| |_|  \____/ \__,_|\__(_)
                __/ |
               |___/
                               `.`
                      .,`     .i;i.
                     ,i;i.    ;:,:;
                    `;..,:   ,:..,:   `..
                    .:..,:   :,..:,  `i;i;
             ,:.    :,..:,  ;,..,:  ;,..,:
            :;;i.   :,..:, .:...:, .;...:,
            ;:,::   ;,..:. ,,...;` :,..,;`
            .:..:,  ;...;``;,..,: ,:...:,
            `;..,: `;...;``;...:, ;,...;`
             ,:..:,.:..,; :,..,; :,...:,
             .;..,;,,...; ;...,:`;....;`
              ;,..::....::,....::,...,;
              :,...............,,....,:
              .:.....................:,
               :,....................,:
               :,.......,......,......;.
               .:......,,....,,........,:;::;;::,`
               `;......,.....,,..........,,,,,,:;i.
                .;,......................,.......,i`
                 ,;,.................,:;:;;:,,,,,;:
                  .;:,.............,:;,`  `.::;;;,
                   `,;;:::::,....,:;,`
                      `,,,.,:;;;;:,`
                       ` ` `` ``
                       ` ` ``
                       ` ` ``
                       . . ``
                       . . ``
                       . .```
             `:;##nz#+**:;...
             #xnxnxxxxxxMMMMxnz+*i;:.`     `.:i***+:
            ,xxnxnxxxxxxxxxxxxxxxMMMMMMxn#+zzzzz+MWWz`
            `nMnMnMMxxxxxxxxxxxxxxxxxxxxn+#####*nWWWWWx
              ,+xxMMMMMMMMMMxxxxxxxxxxxxz######iMWWWWWW`
                 :i*#zxMMMMMMMMMMMMMMMxxnzzzzz#iWWWWWWW`
                        .,;i+znxMMMMMMMMnzzzzzz*WWWWWWx
                                `,:i+#nxxznzzzz*WWWWWW*
                                        .:#nnnn+WWWWWx`
                                           ,*zn#MWWWn.
                                              .:+z#:
 */
